<nav class="main-header">
      <div class="col-md-10 col-lg-10">
        <div class="row">

            <div (click)="exibirInfoUsuario()" class="text-azul bordasArredondadas" style="padding-bottom: 6px">
              <i class="fa fa-user nav-icon"></i>
              <div class="username">{{ token?.nome }}</div>
            </div>
            <div *ngIf="showInfoUsuarios" (mouseleave)="sairInfoUsuario()" style="top:65px;" class="dropdown-menu dropdown-menu-lg dropdown-menu-right show dropdownfont">
              <a href="#" class="dropdown-item">
                Mudar senha
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                Informações da conta
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                Plano
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" (click)="logoff()" class="dropdown-item">
                Sair
              </a>
            </div>

            <div class="bordasArredondadas text-azul" style="width: 110px; margin-left: 10px;padding-bottom: 8px">
              <a href="/ajuda" target="_blank" class="nav-link text-azul">
                <i class="fa fa-question-circle-o nav-icon" style="background-color:rgba(53,66,87,0.52);color: #ffffff"></i>
                <div class="username">Ajuda</div>
              </a>
            </div>

        </div>
      </div>
      <div class="col-md-2 pull-right text-right" style="top:15px;position: absolute;right: 0;">
        <div class="nav-item text-azul text-right pull-right" (click)="exibirNotificacoes()" style="position: relative;">
          <a class="nav-link text-azul" role="button" style="display: inline-block; position: relative;">
            <i class="fa fa-bell-o text-azul nav-icon" style="margin-right: 0;"></i>
            <span *ngIf="notificacoes.length > 0" class="badge badge-warning navbar-badge">{{this.notificacoes.length}}</span>
          </a>
        </div>
        <div (focusout)="sairNotificacao()" (mouseleave)="sairNotificacao()" *ngIf="showNotificacao"
             class="dropdown-menu dropdown-menu-lg dropdown-menu-right show dropdownfont" style="left: inherit; right: 0;top: 45px;">
          <span class="dropdown-item dropdown-header">{{this.notificacoes.length}} Notificações</span>
          <div class="dropdown-divider"></div>
          <a  *ngFor="let notificacao of notificacoes" href="#" class="dropdown-item">
            <p style="font-size: 14px"><i class="fa fa-bell mr-2"></i>{{notificacao.titulo}}</p>
            <p [innerHTML]="notificacao.texto"><span class="float-right text-muted ">{{ notificacao.datacadastro | date:"dd-MM-yyyy" }}</span></p>
          </a>
          <div class="dropdown-divider"></div>
        </div>
      </div>
</nav>
